export default __webpack_public_path__ + "static/media/refresh-small.c6139539.svg";